/**
 * It's a generated file, preferable to extend this in external file
 */
import * as yup from 'common/yup';
import {passphrase} from 'common/yup/customs/passphrase';
import {LdapQueryParams} from 'types/diplomat/LdapQueryParams';
import {DiplomatObject} from 'types/DiplomatObject';
import {enums} from 'types/enums';

export const LdapNames = {
   address: 'address',
   port: 'port',
   verifySslCert: 'verifySslCert',
   sslCertId: 'sslCertId',
   timeout: 'timeout',
   bindingType: 'bindingType',
   userDN: 'userDN',
   password: 'password',
   adminQueryParams: 'adminQueryParams',
   sftpQueryParams: 'sftpQueryParams',
   ldapUsersPath: 'ldapUsersPath',
   assignedRole: 'assignedRole',
} as const;

export const LdapSettings = DiplomatObject.shape({
   [LdapNames.address]: yup.string(),
   [LdapNames.port]: yup.number(),
   [LdapNames.verifySslCert]: yup.boolean(),
   [LdapNames.sslCertId]: yup.string(),
   [LdapNames.timeout]: yup.number(),
   [LdapNames.bindingType]: yup.string().oneOf(enums.bindingType.keys),
   [LdapNames.userDN]: yup.string(),
   [LdapNames.password]: passphrase(),
   [LdapNames.adminQueryParams]: LdapQueryParams,
   [LdapNames.sftpQueryParams]: LdapQueryParams,
   [LdapNames.ldapUsersPath]: yup.string(),
   [LdapNames.assignedRole]: yup.string(),
});
export type ILdapSettings = yup.InferType<typeof LdapSettings>;
